type CalFn = ((...args: unknown[]) => unknown) & {
  loaded?: boolean;
  ns?: Record<string, CalFn>;
  q?: unknown[][];
};

let bootstrapStarted = false;

export function loadCalEmbed(): void {
  if (typeof window === "undefined" || bootstrapStarted) return;
  bootstrapStarted = true;

  (function (C: Window, A: string, L: string) {
    const p = (a: CalFn, ar: unknown[]) => { (a.q ??= []).push(ar); };
    const d = C.document;
    const w = C as unknown as { Cal?: CalFn };
    w.Cal = w.Cal || (function calBootstrap(this: unknown, ...args: unknown[]) {
      const cal = w.Cal as CalFn;
      if (!cal.loaded) {
        cal.ns = {};
        cal.q = cal.q || [];
        const s = d.createElement("script");
        s.src = A;
        d.head.appendChild(s);
        cal.loaded = true;
      }
      if (args[0] === L) {
        const namespace = args[1];
        const api = function (this: unknown, ...inner: unknown[]) {
          p(api as CalFn, inner);
        } as CalFn;
        api.q = api.q || [];
        if (typeof namespace === "string") {
          cal.ns![namespace] = cal.ns![namespace] || api;
          p(cal.ns![namespace], args);
          p(cal, ["initNamespace", namespace]);
        } else {
          p(cal, args);
        }
        return;
      }
      p(cal, args);
    } as unknown as CalFn);
  })(window, "https://app.cal.com/embed/embed.js", "init");

  const w = window as unknown as { Cal: CalFn };
  w.Cal("init", "30min", { origin: "https://cal.com" });
  w.Cal.ns!["30min"]("ui", {
    theme: "dark",
    cssVarsPerTheme: {
      light: { "cal-brand": "#13d8aa" },
      dark: { "cal-brand": "#13d8aa" },
    },
    hideEventTypeDetails: true,
    layout: "month_view",
  });
}

export function mountCalInline(opts: {
  elementOrSelector: string;
  calLink: string;
}): () => void {
  let cancelled = false;
  let timer: ReturnType<typeof setTimeout> | null = null;

  const tryMount = () => {
    if (cancelled) return;
    const w = window as unknown as { Cal?: CalFn };
    const ns = w.Cal?.ns?.["30min"];
    if (typeof ns === "function") {
      ns("inline", {
        elementOrSelector: opts.elementOrSelector,
        config: { layout: "month_view", theme: "dark" },
        calLink: opts.calLink,
      });
      return;
    }
    timer = setTimeout(tryMount, 80);
  };

  loadCalEmbed();
  tryMount();

  return () => {
    cancelled = true;
    if (timer) clearTimeout(timer);
  };
}
